import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el MegaPack después de comprar?',
    a: 'Recibís acceso al material de forma inmediata para que puedas empezar a usarlo cuanto antes, sin esperas ni trámites.'
  }, {
    q: '¿Para qué nivel educativo está pensado?',
    a: 'Está diseñado para docentes de escuelas agrotécnicas, institutos de formación agropecuaria y cualquier nivel educativo donde se dicten materias relacionadas con agricultura, ganadería y producción animal.'
  }, {
    q: '¿El material ya tiene actividades y evaluaciones incluidas?',
    a: 'Sí. Los tomos y libros incluyen actividades prácticas y evaluaciones listas para usar directamente en el aula, sin necesidad de modificarlas.'
  }, {
    q: '¿El material es editable?',
    a: 'El material se entrega en formato PDF de alta calidad, listo para usar en el aula o proyectar en clase.'
  }, {
    q: '¿Cómo pago?',
    a: 'Podés pagar con tarjeta de crédito, débito, transferencia bancaria o Mercado Pago en pesos argentinos.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tenés 7 días de garantía total. Si no estás conforme por cualquier motivo, te devolvemos el 100% de tu dinero sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-[#fdfbf7]" data-id="element-45">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-46">
        <h2 className="text-3xl font-extrabold text-center text-[#1a3622] mb-12" data-id="element-47">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, i) => <div key={i} className="border border-[#e2e8f0] rounded-2xl overflow-hidden bg-white" data-id="element-49">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-[#d4af37] hover:bg-[#f5f0e6] transition-colors" aria-expanded={openIndex === i} data-id="element-50">
                <span className="font-bold text-[#1a3622] pr-4" data-id="element-51">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-[#8b5a2b] transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-52" />
              </button>

              <AnimatePresence data-id="element-53">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-54">
                    <div className="px-6 pb-5 text-[#5c4033] leading-relaxed border-t border-[#e2e8f0] pt-3" data-id="element-55">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}